import Vertical from "./Vertical";
export default Vertical;
